function getToken(): string | null {
  return localStorage.getItem("twin_token");
}

function getRefreshToken(): string | null {
  return localStorage.getItem("twin_refresh_token");
}

function set(access: string, refresh?: { value: string; expiration_time: string }) {
  localStorage.setItem("twin_token", access);
  if (refresh) {
    localStorage.setItem("twin_refresh_token", refresh.value);
  }
}

function clear() {
  localStorage.removeItem("twin_token");
  localStorage.removeItem("twin_refresh_token");
  localStorage.removeItem("twin_user");
}

export const tokenStorage = {
  getToken,
  getRefreshToken,
  set,
  clear,
};
